module.exports = __webpack_public_path__ + "media/images/landing_page/velme_atskirties-112ca9e600fe088c0cea8f4e9f7b9c1d.webp";